import * as React from 'react';

import { InfrastructureControlContainer, InfrastructureDropdownContainer } from './Infrastructure';
import { InfrastructureContextProvider } from './Infrastructure/InfrastructureContext';
import { ListingButtonContainer } from './ListingButton';
import * as styles from './styles.css';
import { Navigation } from '../../components/Navigation';

export const NavigationContainer: React.FC = () => {
  return (
    <Navigation indent="L">
      <InfrastructureContextProvider>
        <div className={styles['navigation-buttons-container']}>
          <InfrastructureControlContainer />
          <ListingButtonContainer />
        </div>
        <InfrastructureDropdownContainer />
      </InfrastructureContextProvider>
    </Navigation>
  );
};

NavigationContainer.displayName = 'NavigationContainer';
